/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    alternative: {
      description: 'Replaces the default green colour with black',
      type: 'variant',
      values: [ true ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    inverse: {
      description: 'Replaces the default green colour with white. Useful for dark backgrounds.',
      type: 'variant',
      values: [ true ]
    },
    quiet: {
      description: 'When it is true, it does not show the decoration',
      type: 'state',
      values: [ true, false ]
    },
    size: { type: 'variant', values: [ 'micro', 'small', 'large' ] }
  },
  rules: [
    {
      if: { expanded: true },
      tokens: { icon: PaletteIconChevronUp }
    },
    { if: { alternative: true }, tokens: { color: '#666666' } },
    {
      if: { inverse: true },
      tokens: { color: '#ffffff', iconColor: '#ffffff' }
    },
    {
      if: { size: 'micro' },
      tokens: { fontSize: 12, iconSize: 16, lineHeight: 1.33333333333 }
    },
    {
      if: { size: 'small' },
      tokens: { fontSize: 14, iconSize: 16, lineHeight: 1.42857142857 }
    },
    {
      if: { size: 'large' },
      tokens: { fontSize: 20, iconSize: 24, lineHeight: 1.4 }
    },
    { if: { quiet: true }, tokens: { textLine: 'none' } },
    {
      if: { alternative: true, quiet: true },
      tokens: { color: '#666666', textLine: 'none' }
    },
    {
      if: { inverse: true, quiet: true },
      tokens: { color: '#ffffff', iconColor: '#ffffff', textLine: 'none' }
    }
  ],
  tokens: {
    borderColor: 'rgba(0, 0, 0, 0)',
    borderWidth: 0,
    color: '#000000',
    fontSize: 16,
    icon: PaletteIconChevronDown,
    iconColor: '#000000',
    iconGap: 8,
    iconPaddingTop: 4,
    iconPosition: 'left',
    iconSize: 16,
    justifyContent: 'flex-start',
    lineHeight: 1.5,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    size: 4,
    textLine: 'none',
    verticalAlign: 'middle'
  }
}
export default theme
